import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad8515d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden-print" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = {
  key: 0,
  class: "region-container"
}
const _hoisted_4 = { class: "m-0 ml-1" }
const _hoisted_5 = { class: "m-0 ml-2 lead" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-12 mt-3" }
const _hoisted_10 = { class: "row align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"col my-1\" data-v-ad8515d2><div class=\"cadac-logo\" data-v-ad8515d2><a href=\"/\" data-v-ad8515d2><svg height=\"43\" width=\"237\" data-v-ad8515d2><use xlink:href=\"#cadac-logo-white\" data-v-ad8515d2></use></svg></a></div></div>", 1)
const _hoisted_12 = { class: "col my-1 d-flex flex-wrap" }
const _hoisted_13 = {
  class: "mr-2",
  href: "/"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href", "target"]
const _hoisted_16 = { class: "col my-1" }
const _hoisted_17 = {
  key: 0,
  class: "iso-icons justify-content-lg-end"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "col my-1" }
const _hoisted_21 = { class: "social-icons justify-content-lg-end" }
const _hoisted_22 = { class: "linkedin" }
const _hoisted_23 = { class: "youtube ml-2" }
const _hoisted_24 = { class: "spotify ml-2" }
const _hoisted_25 = { class: "facebook ml-2" }
const _hoisted_26 = { class: "instagram ml-2" }
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-12 d-flex flex-wrap" }
const _hoisted_29 = { class: "font-weight-500 m-0 mr-2 ml-0" }
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_ChangeRegionModal = _resolveComponent("ChangeRegionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      (_ctx.vm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_ctx.layoutStore.isAuthenticated || !_ctx.vm?.currentUser?.company?.companyName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_Button, {
                    class: "p-button-text p-button-secondary btn-change-region",
                    disabled: _ctx.vm?.availableLocationOptions?.length < 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowRegionModalClick()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'location-dot'],
                        size: "1x"
                      }),
                      _createElementVNode("h5", _hoisted_4, _toDisplayString(`${_ctx.$t("footer.region")}:`), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.currentRegionName), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Divider),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.mainFooterBlocks, (block, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "col-md-6 col-lg-3 d-flex flex-column mb-2"
                }, [
                  (block.header)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(block.header), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.items, (item, itemIndex) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: itemIndex,
                      href: item.url
                    }, _toDisplayString(item.label), 9, _hoisted_8))
                  }), 128))
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("footer.allPricesExclVat")), 1)
              ])
            ]),
            _createVNode(_component_Divider),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t("footer.copyright", { year: new Date().getFullYear()})), 1),
                _createElementVNode("a", {
                  class: "mr-2",
                  href: _ctx.vm.privacyPolicyUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t("footer.privacy")), 9, _hoisted_14),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.termsAndConditions, (term) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "mr-2",
                    key: term.text,
                    href: term.href,
                    target: term.target
                  }, _toDisplayString(term.text), 9, _hoisted_15))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.vm.isoIconsBlock.items && _ctx.vm.isoIconsBlock.items.length && _ctx.vm.isoIconsBlock.isVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.isoIconsBlock.items, (isoItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: isoItem.standardNumber,
                          align: "center",
                          class: "ml-2"
                        }, [
                          _createElementVNode("a", {
                            href: isoItem.certificateLink,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              src: isoItem.icon.url,
                              alt: isoItem.icon.alt
                            }, null, 8, _hoisted_19)
                          ], 8, _hoisted_18)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'linkedin-in'],
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUrl(_ctx.vm.linkedInUrl, ' _blank')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'youtube'],
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUrl(_ctx.vm.youtubeUrl, ' _blank')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'spotify'],
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openUrl(_ctx.vm.spotifyUrl, ' _blank')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'facebook-f'],
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openUrl(_ctx.vm.facebookUrl, ' _blank')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'instagram'],
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openUrl(_ctx.vm.instagramUrl, ' _blank')))
                    })
                  ])
                ])
              ])
            ]),
            _createVNode(_component_Divider),
            (_ctx.vm.subFooterBlock)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.vm.subFooterBlock?.header), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.subFooterBlock.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: index,
                        class: "mr-2",
                        href: item.url
                      }, _toDisplayString(item.label), 9, _hoisted_30))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.layoutStore.changeRegionModalVisible)
      ? (_openBlock(), _createBlock(_component_ChangeRegionModal, {
          key: 0,
          "should-confirm-region": _ctx.vm.showRedirect,
          vm: _ctx.vm.availableLocationOptions
        }, null, 8, ["should-confirm-region", "vm"]))
      : _createCommentVNode("", true)
  ], 64))
}